export default __webpack_public_path__ + "static/media/thylacine.8b7df21a.png";